import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type Params = OpalApiRequestParams<'ReadMomentCustomFieldsV3'>
type Response = OpalApiResponseDocument<'ReadMomentCustomFieldsV3', 200>

export function readMomentCustomFields({
  params,
}: {
  params: Params
}): Promise<Response> {
  const url = new URL(
    `/moments/v3/${params.path.moment_id}/moment_custom_fields`,
    window.location.origin
  )

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
